import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@vr/lib';

const bgTypes = theme => ({
  success: theme.colors.primary,
  warning: theme.colors.secondary,
  error: theme.colors.danger,
});

const colorTypes = theme => ({
  success: theme.colors.white,
  warning: theme.colors.primary,
  error: theme.colors.white,
});

const Container = styled.div`
  display: flex;
  padding: 15px 18px;
  background: ${({ theme, type }) => bgTypes(theme)[type]};
  color: ${({ theme, type }) => colorTypes(theme)[type]};
`;
const Icon = styled(FontAwesomeIcon)`
  margin-right: 15px;
  font-size: 42px;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const Title = styled.p`
  font-weight: 700;
`;
const Description = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  margin-top: 5px;
`;

export default function Toast({ title, children, type }) {
  function handleIcon() {
    let icon;

    if (type === 'success') {
      icon = 'check-circle';
    }
    if (type === 'warning') {
      icon = 'exclamation-triangle';
    }
    if (type === 'error') {
      icon = 'times';
    }

    return <Icon type={type} icon={icon} />;
  }
  return (
    <Container type={type} data-testid="toast-mobile">
      {handleIcon()}
      <Content>
        <Title>{title}</Title>
        <Description>{children}</Description>
      </Content>
    </Container>
  );
}

Toast.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  type: PropTypes.string.isRequired,
};
